module.exports = __webpack_public_path__ + "static/media/secai-greenblack-new.54828464.png";